import React from "react";
import Canvas from './Canvas';
// import Wavesurfer from "wavesurfer.js";

class Message extends React.Component {
    state = {
        position: 0,
        muted: false,
        isLoad: false,
        audioDetails: {},
        record: false
    }
    render() {
        return (
            <div>
                {/* <div style={{ padding: 10, border: '1px solid #ebeaf2', background: '#fff', borderRadius: 15 }}>

                    <div style={{ display: 'flex', flexDirection: 'column', }}>
                        <div className='flexc'>
                            <div style={{ width: 45 }} className='' >
                                <img className='w-100 br-50' src='/images/male.png' alt="" style={{ border: '1px solid #fff' }} />
                                {/* <div className='w-100 br-50' style={{ background: '#ee5050', border: '2px solid #fff' }} /> *
                            </div>
                            <div className='pld-3' >
                                <p>
                                    Zain Ekstrom Bothman
                                </p>
                            </div>
                        </div>
                        <div style={{ borderBottom: '1px solid #F4F5F8', margin: '9px 0ّ' }} />
                        <div className="d-flex">

                            <p className="pt-2" style={{ color: '#A7A7A7', fontWeight: 900, fontSize: 14 }}>
                                Message :
                            </p>
                        </div>
                    </div>

                    <div style={{}} className="  p-2">
                        <div className="d-flex align-items-center">
                            <p className="" style={{ fontSize: 14, color: '#626262' }}>
                                In ipsum risus, eu in sed sem facilisis eget. Nisl volutpat, sagittis aliquet ornare cursus leo. Risus, ut nec amet, aliquam adipiscing. Purus amet bibendum nulla vitae erat gravida dictum habitant at. Et euismod adipiscing dignissim lacinia amet ipsum pellentesque potenti semper.                            </p>
                        </div>
                    </div>
                    <div className="d-flex w-100 p-2 ">
                        <div style={{ borderRadius: 50, width: 45, height: 45, background: '#ECFFE6', padding: 10 }} className='flex-4 mrd-3'>

                            <div style={{ width: 25, height: 25 }}>

                                <img width={'100%'} src='/images/fi-sr-bell.png' alt="" />
                            </div>
                        </div>
                        <div style={{ borderRadius: 50, padding: '7px 20px', background: '#00B828', alignItems: 'center', display: 'flex', justifyContent: 'center' }} className="flex-1 p-2">
                            * <div style={{ width: 45, height: 45 }}>
                                <img width={'100%'} src='/images/replay.png' alt="" />
                            </div> *
                            <div>
                                <p style={{ color: '#fff', textAlign: 'center' }}>

                                    Replay
                                </p>
                            </div>
                        </div>

                    </div>
                </div> */}
                {/* <div style={{ padding: 10, border: '1px solid #ebeaf2', background: '#fff', borderRadius: 15 }}>

                    <div style={{ display: 'flex', flexDirection: 'column', }}>
                        <div className='flexc'>
                            <div style={{ width: 45 }} className='' >
                                <img className='w-100 br-50' src='/images/male.png' alt="" style={{ border: '1px solid #fff' }} />
                                {/* <div className='w-100 br-50' style={{ background: '#ee5050', border: '2px solid #fff' }} /> *
                            </div>
                            <div className='pld-3' >
                                <p>
                                    Zain Ekstrom Bothman
                                </p>
                            </div>
                        </div>

                        <div style={{ borderBottom: '1px solid #F4F5F8', margin: '9px 0' }} />
                        <div style={{ width: "100%", height: "100vh", display: "grid", placeItems: "center" }}>

                            <div style={{ backgroundColor: "rgba(255,255,255,0.3)", width: "400px", height: "400px", position: "relative", boxShadow: '0px 1px 10px rgba(106, 0, 255, 0.3)', borderRadius: 20 }}>

                                <div style={{ marginLeft: 10, width: "175px", height: "50px", backgroundColor: "#fff", boxShadow: '0px 1px 10px rgba(106, 0, 255, 0.3)', display: "flex", alignItems: "center", justifyContent: "space-around", padding: " 0 10px", borderRadius: 10, position: "absolute", bottom: 130, left: 10 }}>
                                    <div style={{ width: "120px", height: "max-content" }}>
                                        <Wavesurfer
                                            src={`./audios/4b8916fe-def4-4ced-b546-950a375083d6.ogg`}
                                            position={this.state.position}
                                            onReady={this.onReadyHandler}
                                            onFinish={() => this.onFinish()}
                                            barGap={3}
                                            barWidth={2}
                                            barHeight={15}
                                            barRadius={2}
                                            height={20}
                                            waveColor={"#6a00ff"}
                                            playing={this.state.play}
                                            cursorColor={"transparent"}
                                            volume={10}
                                        />
                                    </div>
                                    <button onClick={() => this.playVoice()} style={{ width: "35px", height: "35px", borderRadius: "50px", borderColor: "transparent", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                        {this.state.play ? (
                                            <img style={{ width: "17px" }} src="/images/pause.png" />
                                        ) : (
                                            <img style={{ width: "17px" }} src="/images/play.png" />
                                        )}
                                    </button>
                                </div>
                                <br></br>
                                <div style={{ width: "100%", height: "100px", display: "flex", alignItems: "center", justifyContent: "center", position: "absolute", bottom: 20 }}>
                                    <button style={{ width: "40px", height: "40px", borderRadius: "50px", borderColor: "transparent", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", position: "absolute", zIndex: 2, outline: 0 }} onClick={() => this.recordVoice()} >
                                        <img style={{ width: "17px" }} src='/images/mic.png' />
                                    </button>
                                    <div style={{ width: "200px", height: "100px", position: "absolute", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        {/* <Canvas control={this.state.record} ref={el => this.element = el} /> *
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        )
    }
}


export default Message;